const Testimonial = [
  // {
  //     name: 'Megh Makwana',
  //     post: '🌟 Unlocking Potentials | Empowering Teams 🚀 | Passionate People Connector | 𝑪𝒆𝒓𝒕𝒊𝒇𝒊𝒆𝒅 𝑳𝒊𝒏𝒌𝒆𝒅𝑰𝒏 𝑹𝒆𝒄𝒓𝒖𝒊𝒕𝒆𝒓, 𝑻𝒂𝒍𝒆𝒏𝒕 𝑰𝒏𝒔𝒊𝒈𝒉𝒕, 𝒂𝒏𝒅 𝑯𝒖𝒎𝒂𝒏 𝑹𝒆𝒔𝒐𝒖𝒓𝒄𝒆𝒔',
  //     detail: "Prakash is a fun-loving and jolly-natured person, worked with him almost for 6 months during this tenure, and I found him hard word-working to learn the latest tech skills. When I see him I personally feel happy. He spreads positive vibes about the organization. I wish him all the best for his future endeavour.",
  //     date: 'October 15,2022',
  //     livelink: '',
  // },
  // {
  //     name: 'Aakash Sisodiya',
  //     post: 'Founder of Developar',
  //     detail: "Prakash is an excellent resource, and a master at Frontend Development has been a real gem to the clients and contacts. he makes sure all the deadlines meet and that also with the highest standards. he is a hardworking and dedicated person who will complete your project in a given time frame. I would recommend and endorse Prakash.",
  //     date: 'July 29,2022',
  //     livelink: '',
  // },
  // {
  //     name: 'Prakash Sahu',
  //     post: 'Team Lead',
  //     detail: "There is no better colleague than Prakash. He is one of the most dedicated professionals I’ve worked with and is willing to put that extra help whenever you need it. His expertise as a Frontend developer is considerable, and it helped our team come up with more efficient solutions on different projects. His contribution is valuable to the side, and I highly recommend Prakash and would love to work with him again.",
  //     date: 'July 21,2022',
  //     livelink: '',
  // },
  // {
  //     name: 'Hardik Patel',
  //     post: 'Software Engineer',
  //     detail: "Prakash's problem solving skills are out of this world. When everyone thinks it’s the end of the world as we know it, he analyses the problem and helps the team to come up with viable solutions.",
  //     date: 'July 20,2022',
  //     livelink: '',
  // },
  // {
  //     name: 'Umesh Sharma',
  //     post: 'PHP & Laravel devloper',
  //     detail: "We’ve joined our hands on several projects, and Prakash is one of the best people I had as a partner. I highly recommend his expertise to any person looking for an Frontend engineer. He is the most profound person I have met, and his ability to tackle any problem is remarkable and with a warm smile. Prakash would become an appreciated member of any team.",
  //     date: 'July 20,2022',
  //     livelink: '',
  // },
  // {
  //     name: 'Vedant Tirth',
  //     post: 'Front-end Developer',
  //     detail: "Prakash is a well connected professional that always takes the time to support anyone is his network. He has a very impressive background and profile and I recommend Prakash as a Technology expert to connect with and consider for anything appropriate.",
  //     date: 'June 30,2022',
  //     livelink: '',
  // },
  // {
  //     name: 'Poojan Dhorajiya',
  //     post: 'Linux & Git expert | Providing Quality Products to the Client',
  //     detail: "Prakash was a fantastic person to work with, and is not only a multi-skilled and insightful colleague, but also an inspiring strategist. Very good person. Great employee with a very strong problem solving skills. Prakash is an asset to any company.",
  //     date: 'June 30,2022',
  //     livelink: '',
  // },
  {
    name: "Raviraj Rajput (CodeCaste Pvt. Ltd)",
    post: "Back end developer",
    detail:
      "Prakash is one of the best among all the people I have ever worked with. As I remember, Prakash was a very productive person, is hardworking, broad-minded and forward thinking individual. Intelligent, ambitious, energetic and proactive perfectionist. Desire for proficiency and education makes him a valuable asset to the team. Working with him is a signature.",
    date: "May 29,2022",
    livelink: "",
  },
  //   {
  //     name: "Prachi Diwan",
  //     post: "Data Science Master’s Graduate | Machine Learning and Big Data Enthusiast | Python & SQL skilled",
  //     detail:
  //       "He is determined towards the work and projects he takes up. Nonetheless he has also acquired praise worthy skills for Front-end Development which elevates his level of knowledge. Moreover, he accomplish any given task with full dedication and smart work which gives the desired results. Thus, he will be definitely a best fit for the company.",
  //     date: "March 30,2022",
  //     livelink: "",
  //   },
  {
    name: "Hardik Kanak (Softqube Technologies Pvt. Ltd)",
    post: "Project Manager",
    detail: `I had the pleasure of working with Prakash as a Junior Frontend Developer, and his dedication to learning and problem-solving truly impressed me. He has a strong grasp of React.js and frontend development best practices, consistently delivering clean, efficient, and responsive UI components. 

Prakash is proactive in debugging issues and optimizing performance, making him a valuable asset to any development team. His eagerness to grow and adaptability in fast-paced environments set him apart. 

I highly recommend Prakash for any frontend development role—he will undoubtedly bring great value to any team!.`,
    date: "March 29,2022",
    livelink: "",
  },
  {
    name: "Jay Patel (CodeCaste Pvt. Ltd)",
    post: "Front end developer",
    detail:
      "Me and Prakash has been worked together, he was working as Frontend Developer. He has good knowledge and very quick learner, always ready for deep dive related to new things. I noticed one thing he has exact description related to any thing what he has or he was working. He is Good team member.",
    date: "March 29,2022",
    livelink: "",
  },
  
];

export default Testimonial;
